import { Route, Routes } from "react-router-dom";
import { BillingReturn } from "./components/BillingReturn";

import { Archive } from "./pages/Archive";
import { Diagnosis } from "./pages/Diagnosis";
import { Home } from "./pages/Home";
import { Invoices } from "./pages/Invoices";
import { Plans } from "./pages/Plans";

/**
 * 埋め込み SPA のルーティング。host / locale は各画面の遷移時に引き継ぐ。
 */
export function App() {
  return (
    <BillingReturn><Routes>
      <Route path="/" element={<Home />} />
      <Route path="/archive" element={<Archive />} />
      <Route path="/diagnosis" element={<Diagnosis />} />
      <Route path="/invoices/:documentId" element={<Invoices />} />
      <Route path="/plans" element={<Plans />} />
      {/* 未知のパスはホームへ倒す（埋め込み iframe で 404 を出さない）。 */}
      <Route path="*" element={<Home />} />
    </Routes></BillingReturn>
  );
}
